import React from 'react';
import { McDrawer } from "@maersk-global/mds-react-wrapper/components-core/mc-drawer";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";

const ApplicationsDrawer = ({
  isApplicationsDrawerOpen,
  applicationsDrawerHeading,
  applicationsDrawerContent,
  onClose
}) => {
  return (
    <McDrawer
      open={isApplicationsDrawerOpen}
      closed={onClose}
    >
      <span slot="heading" style={{ color: "#0073ab" }}>
        {applicationsDrawerHeading || "Applications"}
      </span>
      <div style={{ marginTop: "10px" }}>
        {applicationsDrawerContent}
      </div>
      <McButton slot="footer" dialogaction="close" onClick={onClose}>
        Close
      </McButton>
    </McDrawer>
  );
};

// Custom hook for applications drawer functionality
export const useApplicationsDrawer = (userDetails, edit, inputNameValue1) => {
  const handleApplicationsDrawerOpen = () => {   
    const heading = edit ? "My Applications" : "Applications";
    const applications = userDetails.applications || [];
    
    let drawerContent;
    if (applications.length > 0) {
      drawerContent = (
        <div>
          <p style={{ marginBottom: "16px", color: "#666" }}>
            Total: {applications.length}
          </p>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: 0 }}>
            {applications.map((application, index) => (
              <li key={`app-${index}-${application.replace(/\s+/g, '-')}`} style={{ marginBottom: "16px", color: "#333" }}>
                <a
                  href={`${process.env.REACT_APP_MSA_LINK}/asset_lookup?applicationName=${encodeURIComponent(application)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#333",
                    textDecoration: "none",
                    cursor: "pointer"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#0073ab";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#333";
                  }}
                >
                  {application}
                </a>
              </li>
            ))}
          </ul>
        </div>
      );
    } else {
      const userName = edit ? "you" : (inputNameValue1 || "user");
      drawerContent = (
        <p style={{ color: "#666" }}>
          No applications found for {userName}.
        </p>
      );
    }
    
    console.log('Drawer state set:', {
      heading,
      hasApplications: applications.length > 0,
      applicationsCount: applications.length,
      isOpen: true
    });

    return { heading, drawerContent };
  };

  return { handleApplicationsDrawerOpen };
};

export default ApplicationsDrawer;
